//将秒转化为时分秒
export function formateSeconds(endTime) {
  let secondTime = parseInt(endTime); //将传入的秒的值转化为Number
  let min = 0; // 初始化分
  let h = 0; // 初始化小时
  let result = "";
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    min = Math.floor(secondTime / 60); //获取分钟，除以60取整数，得到整数分钟
    secondTime = Math.floor(secondTime % 60); //获取秒数，秒数取佘，得到整数秒数
    if (min > 60) {
      //如果分钟大于60，将分钟转换成小时
      h = Math.floor(min / 60); //获取小时，获取分钟除以60，得到整数小时
      min = Math.floor(min % 60); //获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }
  result = (h > 0 ? `${h.toString()}小时` : '');
  result += (min > 0 ? `${min.toString()}分` : '');
  result += `${secondTime.toString()}秒`;
  return result;
}

export function timeFormat(param) {
  return param < 10 ? "0" + param : param;
}

export function formateDate(myDate) { //将时间格式化为 yyyy-mm-dd HH:mm:ss
  let y = myDate.getFullYear(); // 年
  let m = myDate.getMonth() + 1; // 月
  let day = myDate.getDate(); // 日
  let hou = myDate.getHours(); //时
  let min = myDate.getMinutes(); //分
  let sec = myDate.getSeconds(); //秒
  let countTime = {
    m: timeFormat(m),
    day: timeFormat(day),
    hou: timeFormat(hou),
    min: timeFormat(min),
    sec: timeFormat(sec),
  };
  let strDate = String(y) + "-" + countTime.m + "-" + countTime.day;
  return strDate;
}

//手机号隐藏中间四位
export function hideTel(tel) {
  var reg = /^(\d{3})\d*(\d{4})$/;
  var newTel = tel.replace(reg, '$1****$2');
  return newTel;
}
export function isArray(value) {
  return Array.isArray(value);
}
export function isEmpty(value) {

  if (value == null || value == "null" || (typeof value === "string" && value.replace(/\s*/g, "").length == 0)) {
    return true;
  } else {
    return false;
  }

}
export function isPhoneNumber(phoneNumber) {
  let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!myreg.test(phoneNumber)) {
    return false;
  } else {
    return true;
  }
}
export function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search
    .substr(1)
    .replace(/\?/g, "&")
    .match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

//获取当前PC端的域名
export function getPcOrigin() {
  let origin = window.location.origin;
  if (window.location.host === "www.chineseall.cn") {
    return "https://shuxiang.chineseall.cn";
  } else if (origin.indexOf("chineseall.cn") === -1) { //不是chineseall域名
    return "https://shuxiang.chineseall.cn";
  } else {
    return origin;
  }
}
//获取当前移动端的域名
export function getH5Origin() {
  let origin = window.location.origin;
  if (origin.indexOf(".w.chineseall.cn") === -1) { //不是.w.chineseall域名
    return "https://shuxiang.w.chineseall.cn";
  } else {
    return origin;
  }
}

export function isInstalled(returnUrl) {
  var name = "微书房";
  var the_href = "https://html.chineseall.cn/assets/html/download/app/index.html?type=sx"; //"http://app99.chineseall.cn/DownloadApp/index"; //获得下载链接
  window.location.href =
    "microbook://localWeb/DownloadApp?returnUrl=" + returnUrl
    + "&type=theme&name="
    + name; //打开某手机上的某个app应用
  setTimeout(function () {
    window.location = the_href; //如果超时就跳转到app下载页
  }, 300);
}
//{"ostype":"ios|android","osversion":"x.x.x","appversion":"x.x.x"}
export function getAppEnv() {
  if (window.platform && window.platform.getAppEnvironment) {
    let obj = JSON.parse(window.platform.getAppEnvironment());
    //let obj= window.platform.getAppEnvironment();
    console.log("getAppEnvironment:", obj);
    return obj;
  } else {
    console.log("tool 未检测到 getAppEnvironment 方法！");
    return null;
  }
}
//  {"isLogined":true|false,"token":"xxxxxx","hosts"}
export function getUserInfo() {
  if (window.platform && window.platform.getUserInfo) {
    let userObj = JSON.parse(window.platform.getUserInfo());
    //let userObj= window.platform.getUserInfo();
    console.log("getUserInfo:", userObj);
    return userObj;
  } else {
    console.log("tool 未检测到 getUserInfo 方法！");
    return null;
  }
}



